import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

/**
 * Mock Data Warning Banner
 * Shows when PNRs have demo/mock data and provides refresh option
 */
export const MockDataBanner = ({ 
  mockPnrCount, 
  onRefreshAll, 
  isRefreshing 
}) => {
  if (mockPnrCount === 0) return null;

  return (
    <Card className="bg-amber-900/20 border-amber-700/50 mb-6">
      <CardContent className="p-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <AlertCircle className="w-5 h-5 text-amber-400 flex-shrink-0" />
            <div>
              <p className="text-amber-200 text-sm font-medium">
                {mockPnrCount} PNRs have demo data
              </p>
              <p className="text-amber-400/70 text-xs">
                RapidAPI was temporarily unavailable. Click "Refresh All" when the API is back online.
              </p>
            </div>
          </div>
          <Button
            size="sm"
            variant="outline"
            onClick={onRefreshAll}
            disabled={isRefreshing}
            className="border-amber-600/50 text-amber-300 hover:bg-amber-800/30 hover:text-amber-200 flex-shrink-0"
            data-testid="refresh-all-mock-btn"
          >
            {isRefreshing ? (
              <RefreshCw className="w-4 h-4 mr-2 spinner" />
            ) : (
              <RefreshCw className="w-4 h-4 mr-2" />
            )}
            Refresh All
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default MockDataBanner;
